import { FAQSection } from "../components/FAQSection";

export function FAQPage() {
  return <FAQSection />;
}
